<template>
  <div>
  <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-sm-6 offset-sm-3">
              <div class="white row">
                <div class="col-12 text-center">
                  <h1>Registro</h1>
                </div>
              </div>
              <div class="row">
                <div class="formulario col-12 bgblanco rounded pt-5 pb-4">
                  <form method="post" @submit="submitFormulario($event)">

                    <label>
                      <input
                        type="text"
                        v-model="nombre"
                        maxlength="100"
                        placeholder="Nombre"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="number"
                        v-model="edad"
                        maxlength="100"
                        placeholder="Edad"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="text"
                        v-model="domicilio"
                        maxlength="100"
                        placeholder="Domicilio"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="tel"
                        v-model="telefono"
                        maxlength="100"
                        placeholder="Teléfono"
                        required
                      />
                    </label>

                    <label>
                      <select 
                        v-model="tiposervicio"
                        required
                      >
                        <option value="" hidden>Tipo de servicios que impartes</option>
                        <option value="opcion1">opcion1</option>
                        <option value="opcion2">opcion2</option>
                      </select>
                    </label>

                    <label>
                      <input
                        type="email"
                        v-model="email"
                        maxlength="100"
                        placeholder="Email"
                        pattern="[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}"
                        required
                      />
                    </label>

                    

                    <label>
                      <input
                        type="password"
                        v-model="password"
                        maxlength="100"
                        placeholder="Contraseña"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="password"
                        v-model="password2"
                        maxlength="100"
                        placeholder="Confirmar contraseña"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        v-model="terminos"
                        required
                      />
                      <span class="nota">
                        He leído y estoy de acuerdo con los términos y condiciones del <router-link to="/aviso-de-privacidad">Aviso de Privacidad</router-link>
                        </span> 
                    </label>

                    <div class="text-center pt-2">
                      <button type="submit" class="submit btnnaranja">ENVIAR</button>
                    </div>

                    <div class="pt-2 text-center nota">
                      Nota: Favor de llevar a tu primera cita copia de comprobante de domicilio reciente, copia de credencial de elector o identificación oficial con fotografía, 500 pesos de cuota de inscripción.
                    </div>
                  </form>
                </div>
              </div>
              <div class="row p-3">
               <div class="col-12 text-center white">
                  ¿Ya tienes cuenta?
                  <router-link class="link" to="/">Inicia sesión aquí</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div class="container">
          <div class="row p-2">
            <div class="col-12 text-center">
              <div class="texto">
                <span class="px-1">
                  ConsultoriosMX
                  <sup>&reg;</sup> 2020
                </span>

                <br class="d-block d-md-none" />
                <span class="d-none d-md-inline-block">|</span>
                <router-link
                  to="/terminos-y-condiciones"
                  target="_blank"
                  class="mx-1"
                >&nbsp;Términos y condiciones</router-link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>

import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "" 
    };
  },
  mounted: function(){
    AOS.init();
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        tel: this.tel,
        no_ticket: this.no_ticket,
        sede: this.sede
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      formData.append("cv", this.file);

      console.log("enviando");
      console.log(this.file);
      console.log(JSON.stringify(userData));

      //   this.$http
      //     .post(
      //       "https://www.superbowlexperience.com.mx/upload.php",
      //       //"http://temp-big-game-experience.pautacreativa.mx/upload.php",
      //       formData,
      //       {
      //         emulateJSON: true,
      //         httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      //         headers: {
      //           "Content-Type": "multipart/form-data"
      //           //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      //         }
      //       }
      //     )
      //     .then(
      //       response => {
      //         // get body data
      //         console.log("envio");
      //         console.log(response);
      //         vm.$store.state.loading = false;
      //         console.log(response.data);
      //         var res = response.data;

      //         if (res.status == "ok") {
      //           this.registro = 1;
      //         } else if (res.status == "notok") {
      //           swal.fire("Oops", res.msg, "warning");
      //         }
      //       },
      //       error => {
      //         // error callback
      //         console.log("error callback");
      //         console.log(error);
      //         vm.$store.state.loading = false;
      //         //console.log(userData);
      //         swal.fire(
      //           "Oops",
      //           "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
      //           "warning"
      //         );
      //       }
      //     );

      this.$router.push("registro");
    }
  }
};
</script>

